export default {
    ENV: 'production',
    authApiUrl: 'https://api.imaginelearning.com',
    redirectUri: 'https://my.imaginelearning.com/login/initiate',
    auth0RedirectUri: 'https://my.imaginelearning.com/login/sso',
    auth0Audience: 'https://api.my.imaginelearning.com',
    auth0AuthorizeUrl: 'https://imaginelearning.auth0.com/authorize',
    auth0ClientId: 'DNYZdCYVU6ZlMxeQzvEoBvZDPec4PEm7',
    unityLaunchUrl: 'https://my.imaginelearning.com/player',
    pssUrl: 'https://api.imaginelearning.com/productSelection',
    imlpApiUrl: 'https://identity.app.edgenuity.com/api',
    oauthSsoUrl: 'https://identity.app.edgenuity.com/api/auth/sso/oauth',
    cleverSsoUrl: 'https://identity.app.edgenuity.com/api/auth/sso/clever',
    imlpIlApiUrl: 'https://identity.imaginelearning.com/api',
    oauthSsoIlUrl: 'https://identity.imaginelearning.com/api/auth/sso/oauth',
    cleverSsoIlUrl: 'https://identity.imaginelearning.com/api/auth/sso/clever',
    permissionsApiUrl: 'https://api.imaginelearning.com/v1.0/permissions',
    configCatApiUrl: 'https://flag-proxy.platform-prod.imaginelearning.com',
    configCatSdkKey: 'configcat-proxy/axs-sso-imlp-prod',
    configCatPollIntervalSeconds: 60,
    configCatRequestTimeoutMs: 30000,
    configCatMaxRetries: 3
};
